var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/tagProducts.d9016f37.png","uri@2x": __webpack_public_path__ + "static/media/tagProducts.6d2df669.png","uri@3x": __webpack_public_path__ + "static/media/tagProducts.523b3001.png",
    width: 21,
    height: 17
});